<ng-template #overridesPopover>
  @for (override of scheduleOverrides; track override) {
    <span class="u_block">{{ override }}</span>
  }
</ng-template>
<div>
  <div class="flex-row layout-md-folded">
    <search-filter
      class="tw-w-full"
      [filterConfig]="filterConfig"
      [search]="searchState.getSearchObject()"
      [doSearch]="doSearch"
    ></search-filter>
    @if (enableSubcompanies) {
      <div
        class="tw-flex tw-flex-row xl:!tw-flex-row-reverse tw-justify-between tw-items-center tw-min-w-[270px] tw-ml-3 tw-mt-3 xl:!tw-mt-0"
      >
        <div class="tw-flex tw-flex-row tw-items-center">
          <mat-slide-toggle
            class="mr-0"
            id="allCompaniesToggle"
            [disabled]="subcompanyDistributionDisabled"
            (change)="toggleAllCompanies($event.checked)"
            [checked]="distributeToSubcompanies"
            aria-labelledby="allCompaniesLabel"
          >
          </mat-slide-toggle>
          <label
            for="allCompaniesToggle"
            id="allCompaniesLabel"
            class="tw-ml-2 tw-cursor-pointer tw-font-normal"
            >Select displays from all companies</label
          >
        </div>
        <a
          href="#"
          uiSref="apps.purchase.home"
          (click)="closeEvent.emit()"
          class="madero-link u_nowrap u_inline-block ml-5 ml-sm-3"
          [shown]="subcompanyDistributionAvailable === null"
          >Subscription Required</a
        >
        <a
          actionLink
          (click)="showUpgradePlanModal()"
          class="madero-link u_nowrap u_inline-block ml-5 ml-sm-3"
          [shown]="
            subcompanyDistributionAvailable !== null &&
            !subcompanyDistributionAvailable
          "
          >Plan Upgrade Required</a
        >
      </div>
    }
  </div>
  <div
    class="tw-flex tw-flex-col tw-gap-4 tw-px-[16px] tw-border-solid tw-border-0 tw-border-b tw-border-gray-200"
  >
    @if (canUseFolders()) {
      <folder-path
        [folderTree]="folderService.folderPathTree"
        [folderId]="searchState.getSearchObject().folderId"
        (folderClicked)="onFolderClicked($event)"
        rootName="Displays"
      ></folder-path>
    }
  </div>
  <div
    rvSpinner="display-list-loader"
    [rvShowSpinner]="loadingItems()"
    [shown]="
      !(
        !loadingItems() &&
        list().length === 0 &&
        searchState.getSearchObject().query === undefined
      )
    "
  >
    <cdk-virtual-scroll-viewport
      #scrollViewport
      itemSize="68"
      class="scrollable-list horizontal-scroll"
    >
      <table id="displayListTable" class="table">
        <thead class="table-header">
          <tr class="table-header__row">
            <th class="table-header__cell u_clickable tw-w-10">
              <mat-checkbox
                class="mr-0"
                (click)="toggleAllDisplays()"
                [ngModel]="areAllDisplaysSelected()"
              ></mat-checkbox>
            </th>
            <th
              id="tableHeaderName"
              (click)="searchState.sortBy('name')"
              class="table-header__cell u_clickable tw-w-md"
            >
              Name
              @if (searchState.getSearchObject().sortBy === 'name') {
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-caret-up': !searchState.getSearchObject().reverse,
                    'fa-caret-down': searchState.getSearchObject().reverse,
                  }"
                ></i>
              }
            </th>
            @if (enableSubcompanies) {
              <th
                id="tableHeaderCompanyName"
                class="table-header__cell tw-w-sm"
              >
                Company
              </th>
            }
            <th id="tableHeaderLicensed" class="table-header__cell tw-w-20">
              Licensed
            </th>
            <th id="tableHeaderLicensed" class="table-header__cell tw-w-24">
              Status
            </th>
            <th
              id="tableHeaderLastConnection"
              class="table-header__cell tw-w-sm"
            >
              Last Connection
            </th>
            <th id="tableHeaderSchedule" class="table-header__cell tw-w-md">
              Schedule
            </th>
          </tr>
        </thead>

        <tbody class="table-body">
          <ng-container *cdkVirtualFor="let listItem of list()">
            @if (listItem.isFolder) {
              <tr
                (click)="onFolderClicked(listItem.item.id)"
                class="table-body__row clickable"
                [class.selected]="listItem.selected"
              >
                <td class="table-body__cell">&nbsp;</td>
                <td
                  class="table-body__cell display-name tw-max-w-md tw-font-medium"
                >
                  <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
                    <mat-icon svgIcon="folder" class="tw-text-gray-500" />
                    <a class="madero-link tw-font-medium u_ellipsis-lg">
                      {{ listItem.item.name }}
                    </a>
                  </div>
                </td>
                @if (enableSubcompanies) {
                  <td>&nbsp;</td>
                }
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td class="table-body__cell tw-max-w-sm">
                  <change-details
                    [changeDate]="listItem.item.changeDate"
                    [changedBy]="listItem.item.changedBy"
                  />
                </td>
                <td>&nbsp;</td>
              </tr>
            } @else {
              <tr class="table-body__row display">
                <td class="table-body__cell !tw-pl-[16px] tw-w-10">
                  <mat-checkbox
                    class="mr-0"
                    (click)="
                      toggleDisplay(listItem.item.id, listItem.item.companyId)
                    "
                    [ngModel]="isSelected(listItem.item.id)"
                  ></mat-checkbox>
                </td>
                <td
                  id="displayName-{{ listItem.item.id }}"
                  class="table-body__cell display-name tw-max-w-md tw-font-medium"
                >
                  <span
                    class="tw-truncate tw-w-full tw-inline-block tw-cursor-pointer"
                    (click)="
                      toggleDisplay(listItem.item.id, listItem.item.companyId)
                    "
                  >
                    {{ listItem.item.name }}
                  </span>
                </td>
                @if (enableSubcompanies) {
                  <td
                    id="companyName-{{ listItem.item.id }}"
                    class="table-body__cell tw-max-w-sm tw-overflow-hidden tw-font-medium"
                  >
                    <span class="tw-truncate tw-w-full tw-inline-block">{{
                      listItem.item.companyName
                    }}</span>
                  </td>
                }
                <td
                  id="licensed-{{ listItem.item.id }}"
                  class="table-body__cell tw-flex tw-items-center tw-justify-center tw-w-20 tw-font-normal"
                >
                  @if (listItem.item.playerProAuthorized) {
                    <mat-icon class="small medium" svgIcon="check"></mat-icon>
                  }
                </td>
                <td
                  id="status-{{ listItem.item.id }}"
                  class="table-body__cell tw-w-24 tw-overflow-hidden tw-font-normal"
                >
                  @if (
                    displayService.showLicenseRequired(listItem.item) &&
                    listItem.item.onlineStatus !== 'not_activated'
                  ) {
                    <span class="tw-truncate tw-w-full tw-inline-block">
                      License Required
                    </span>
                  } @else {
                    <display-status
                      [onlineStatus]="listItem.item.onlineStatus"
                      [screenPowerStatus]="listItem.item.screenPowerStatus"
                    ></display-status>
                  }
                </td>
                <td
                  id="lastConnection-{{ listItem.item.id }}"
                  class="table-body__cell display-address tw-max-w-sm tw-overflow-hidden tw-font-normal"
                >
                  @if (displayService.showLicenseRequired(listItem.item)) {
                    <span class="tw-truncate tw-w-full tw-inline-block">
                      License Required
                    </span>
                  } @else {
                    <span class="tw-truncate tw-w-full tw-inline-block">
                      {{
                        listItem.item.lastActivityDate
                          | date: 'd-MMM-yyyy h:mm a'
                      }}
                    </span>
                  }
                </td>
                <td
                  id="schedule-{{ listItem.item.id }}"
                  class="table-body__cell display-schedule tw-max-w-md tw-overflow-hidden tw-font-normal"
                >
                  <div class="u_nowrap flex-row">
                    @if (displayService.hasSchedule(listItem.item)) {
                      <span
                        class="u_ellipsis-md schedule-view tw-truncate tw-w-full tw-inline-block"
                      >
                        {{ listItem.item.scheduleName }}
                      </span>
                    } @else {
                      <span
                        class="u_ellipsis-md tw-truncate tw-w-full tw-inline-block"
                      >
                        {{
                          listItem.item.overrideScheduleNames?.length > 0
                            ? 'No Default Schedule'
                            : 'No Schedule Selected'
                        }}
                      </span>
                    }
                    @if (listItem.item.overrideScheduleNames?.length > 0) {
                      <span
                        class="badge badge-primary u_clickable tw-ml-2 tw-flex tw-items-center tw-justify-center tw-min-w-10 tw-h-8 tw-rounded-full"
                        [popover]="overridesPopover"
                        (onShown)="
                          showPopover(listItem.item.overrideScheduleNames)
                        "
                        containerClass="madero-style"
                        outsideClick="true"
                        placement="bottom right"
                      >
                        +{{ listItem.item.overrideScheduleNames.length }}
                      </span>
                    }
                  </div>
                </td>
              </tr>
            }
          </ng-container>
          <!-- If no search results -->
          @if (
            !loadingItems() &&
            list().length === 0 &&
            searchState.getSearchObject().query !== undefined
          ) {
            <tr class="table-body__row">
              <td colspan="3" class="text-center">
                Your search didn't return any results.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>
  <!--panel-->
</div>

<div
  class="border-container text-center u_margin-md-top u_margin-md-bottom"
  [shown]="
    !loadingItems() &&
    list().length === 0 &&
    searchState.getSearchObject().query === undefined
  "
>
  <div class="panel-body">
    <div class="form-group my-4">
      Add a display to start communicating better with your audience!
    </div>
    <a
      id="displayAddButton"
      class="btn btn-primary btn-toolbar-wide mb-2"
      (click)="closeEvent.emit()"
      uiSref="apps.displays.add"
    >
      Add Display
    </a>
  </div>
</div>
